import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBank } from "src/models/Prices/Bank.models";

interface BankState {
  banks: IBank[];
  bankToEdit: IBank | null;
}

const initialState: BankState = {
  banks: [],
  bankToEdit: null,
};

const BankSlice = createSlice({
  name: "Bank",
  initialState,
  reducers: {
    setBankList: (state, action: PayloadAction<IBank[]>) => {
      state.banks = action.payload;
    },
    setBankToEdit: (state, action: PayloadAction<IBank | null>) => {
      state.bankToEdit = action.payload;
    },
    concatListBank: (state: BankState, action: PayloadAction<IBank[]>) => {
      state.banks = [...state.banks.concat(action.payload)];
    },
    addBank: (state, action: PayloadAction<IBank>) => {
      state.banks.push(action.payload);
    },
    updateBank: (state, action: PayloadAction<IBank>) => {
      let itemIndex = state.banks.findIndex(
        item => item.bankId === action.payload.bankId
      );
      if (itemIndex !== -1) state.banks[itemIndex] = action.payload;
    },
    deleteBank: (state, action: PayloadAction<number>) => {
      const newArray = state.banks.filter(
        item => item.bankId !== action.payload
      );
      state.banks = newArray;
    },
  },
});

export const {
  setBankList,
  concatListBank,
  setBankToEdit,
  addBank,
  updateBank,
  deleteBank,
} = BankSlice.actions;

export default BankSlice.reducer;
